module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Swiss-knife-527b7ac7ba0785f4980ca8f450f95da2.svg";